var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBootstrap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.745,
    height: 48.745,
    viewBox: "0 0 48.745 48.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bootstrap",
    transform: "translate(-6 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M54.745,47.975a6.769,6.769,0,0,1-6.77,6.77H12.77A6.77,6.77,0,0,1,6,47.975V12.77A6.77,6.77,0,0,1,12.77,6h35.2a6.769,6.769,0,0,1,6.77,6.77Z",
    fill: "#673ab7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M39.413,30.415a6.673,6.673,0,0,0-3.791-2.5,6.1,6.1,0,0,0,2.627-2.37,7.965,7.965,0,0,0,1.124-4.306A7.74,7.74,0,0,0,36.2,14.559,13.322,13.322,0,0,0,27.66,12H15V44.5H29.123c3.832-.027,6.716-.853,8.679-2.437,1.95-1.611,2.925-3.994,2.925-7.176A7.425,7.425,0,0,0,39.413,30.415Zm-16.289-13h5.755a3.724,3.724,0,1,1,0,7.447H23.124Zm6.77,21.664h-6.77V30.956h6.77a4.062,4.062,0,1,1,0,8.124Z",
    transform: "translate(3.186 2.124)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.28b00dca8ab2454b3fa9ab25ec6316cf.svg";
export { ForwardRef as ReactComponent };